import { Component, Input, OnInit } from '@angular/core';
import { SignatureProvider } from 'src/app/models/signatureProvider';

@Component({
  selector: 'app-performactionauthenticate',
  templateUrl: './performactionauthenticate.component.html'
})
export class PerformActionAuthenticateComponent implements OnInit {

  @Input('signatureProvider') signatureProvider!: SignatureProvider;
  @Input('signatureProviderUrl') signatureProviderUrl!: string;
  providerUrl!: string;

  constructor() {
    //ngOnInit may not be empty
  }

  ngOnInit(): void {
    this.providerUrl = this.signatureProvider.logo ? this.signatureProvider.logo : '';
  }
}
